import React, { Component } from 'react';
import { Form, Input, Button, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styles from './style.less';

const { Option } = Select;

class Search extends Component {
  handleSearch = (values) => {
    if (!values.keyword) return;
    this.props.handleSearch(values.keyword);
  };

  handleReset = () => {
    this.form.resetFields(); //清空表单
    this.props.handleSearch('');
  };

  render() {
    const { styles } = this.props;
    return (
      <div
        style={{
          background: 'rgba(255,255,255,0.55)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          display: 'flex',
          paddingTop: '16px',
          paddingBottom: '12px',
          paddingLeft: '64px',
          borderBottom: '1px solid rgba(255,255,255,0.7)',
          position: 'relative',
          zIndex: 2,
          ...styles,
        }}
      >
        <Form
          layout="inline"
          onFinish={this.handleSearch}
          ref={(form) => {
            this.form = form;
          }}
        >
          <Form.Item name="keyword">
            <Input
              style={{ width: 220, borderRadius: '18px', background: 'rgba(255,255,255,0.85)' }}
              prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="搜索竞赛关键字"
              allowClear
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ borderRadius: '18px' }}>
              查询
            </Button>
          </Form.Item>
        </Form>
        <Button
          type="primary"
          onClick={this.handleReset}
          style={{ marginRight: '17px', marginLeft: '8px', borderRadius: '18px' }}
        >
          重置
        </Button>
      </div>
    );
  }
}

export default Search;
